export const Header = (props) => {
  return (
    <header id="header">
      <div className="intro">
        <div className="overlay">
          <div className="container">
            <div className="row">
              <div className="col-md-10 col-md-offset-1 intro-text">
                <p className="intro-eyebrow">Consumer Products · Brand Development · Distribution</p>
                <h1>{props.data ? props.data.title : "Loading"}</h1>
                <p className="intro-sub">{props.data ? props.data.paragraph : "Loading"}</p>
                <div className="intro-cta-group">
                  <a href="#products"    className="btn btn-custom btn-lg page-scroll">Explore Products</a>
                  <a href="#distributor" className="btn btn-outline-hero btn-lg page-scroll">Become a Partner</a>
                </div>
                <div className="trust-strip">
                  {[
                    { icon: "fa-cubes",   label: "Growing Product Portfolio" },
                    { icon: "fa-trademark", label: "Multi-Brand Company" },
                    { icon: "fa-truck",   label: "Pan-India Distribution" },
                    { icon: "fa-globe",   label: "Export Supply — India & Beyond" },
                  ].map((t, i) => (
                    <div key={i} className="trust-item">
                      <i className={`fa ${t.icon}`}></i>
                      <span>{t.label}</span>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};
